import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import CategoryList from '../../components/CategoryList/CategoryList'

const mapStateToProps = state => ({
  contentAreas: state.cms.data.contentAreas,
  seoArea: state.seo.data.seoArea,
  loader: state.application.loader,
  destinationPageType: state.application.destinationPageType
})

export default withRouter(connect(mapStateToProps)(CategoryList))
